export const WebpageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://sarasiruhamresort.com/#webpage",
  url: "https://sarasiruhamresort.com/",
  name: "Sarasiruham Resort | Luxury Private Pool Resort in Udaipur",
  inLanguage: "en-IN",
  isPartOf: {
    "@id": "https://sarasiruhamresort.com/#website",
  },
  about: {
    "@id": "https://sarasiruhamresort.com/#hotel",
  },
  mainEntity: {
    "@id": "https://sarasiruhamresort.com/#hotel",
  },
};
